window.Products.DeviceCase.GalaxyS6Edge = function() {
};
window.Products.DeviceCase.GalaxyS6Edge.inherits(window.Products.DeviceCase.DeviceCase);
window.Products.DeviceCase.GalaxyS6Edge.id = 51;
window.Products.DeviceCase.GalaxyS6Edge.slug = 'galaxy-s6-edge';

window.Products.DeviceCase.GalaxyS6Edge.prototype.set3dProperties = function(modelViewer) {
	this.updateThreeTexture(modelViewer);
	modelViewer.object.position.y = -0.71;
	modelViewer.camera.position.z = 8;
};

window.Products.DeviceCase.GalaxyS6Edge.prototype.setThreeControls = function(controls) {
	controls.minDistance = 3.4;
	controls.maxDistance = 4.4;
};